import Button from "antd/lib/button";
import { colors } from "../../styles/themes";
import { sizes } from "../../styles/sizes";

const Word = (props: {
  onClick: () => void;
  isActive: boolean;
  style?: React.CSSProperties;
  item: string;
  row: number;
  col: number;
}) => {
  const { style, isActive, row, col, item, ...restProps } = props;
  const maxWordWidth = Math.max(...item.split(" ").map((i) => i.length));
  const fontSize = `min(20px, calc(${sizes.wordWidth} / (1 + ${maxWordWidth}) * 1.4))`; // Math.min(20, (baseWidth / maxWordWidth) * 6);
  return (
    <Button
      {...restProps}
      type="primary"
      className="wordButton"
      data-active={isActive ? "true" : undefined}
      aria-pressed={isActive}
      style={{
        width: sizes.wordWidth,
        height: sizes.wordHeight,
        background: props.isActive ? colors.wordBgActive : colors.wordBg,
        color: props.isActive ? colors.wordTextActive : colors.wordText,
        fontSize: `${fontSize}`,
        fontFamily: "Open Sans",
        fontWeight: "bold",
        textTransform: "uppercase",
        whiteSpace: "break-spaces",
        margin: "3px",
        padding: "0",
        boxShadow: "0 0 0 0",
        ...style,
      }}
    >
      <b>{item}</b>
    </Button>
  );
};

export default Word;
